<mat-form-field>
    <mat-label>{{ resources.AllocationScaniaUnit }}</mat-label>
    <mat-select [(ngModel)]="selected" (ngModelChange)="onChange($event)">
        <mat-option *ngFor="let scaniaUnit of scaniaUnitList | async" [value]="scaniaUnit.id">
            {{scaniaUnit.name}} - {{scaniaUnit.description}}
        </mat-option>
    </mat-select>
</mat-form-field>